const initState = {
  tutorials: [],
};
const tutorialsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_TUTORIAL":
      return {
        ...state,
        tutorials: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default tutorialsReducer;
